import React, { useState } from "react";
import PropTypes from "prop-types";
import Grecaptcha from "./Grecaptcha";

const InvisibleRecaptcha = (props) => {
    const {
        useRecaptcha = true,
        formStyles,
        grecaptchaApiKey,
        hiddenOnMobile = false,
        onCaptchaResponse,
        children
    } = props;
    const [ grecaptchaId, setGrecaptchaId ] = useState(null);

    if (!useRecaptcha) {
        return (
            <form
                className={ formStyles }
                onSubmit={ (event) => {
                    event.preventDefault();

                    onCaptchaResponse(null);
                } }
            >
                { children }
            </form>
        );
    }

    const onSubmit = (event) => {
        event.preventDefault();

        grecaptcha.execute(grecaptchaId);
    };

    return (
        <form className={ formStyles } onSubmit={ onSubmit }>
            { children }
            <Grecaptcha
                grecaptchaApiKey={ grecaptchaApiKey }
                elementId="grecaptchaSubmitButton"
                size="invisible"
                onCaptchaResponse={ onCaptchaResponse }
                setGrecaptchaId={ setGrecaptchaId }
                hiddenOnMobile={ hiddenOnMobile }
            />
        </form>
    );
};

InvisibleRecaptcha.propTypes = {
    useRecaptcha: PropTypes.bool,
    formStyles: PropTypes.string,
    onCaptchaResponse: PropTypes.func.isRequired,
    grecaptchaApiKey: PropTypes.string.isRequired,
    hiddenOnMobile: PropTypes.bool
};

export default InvisibleRecaptcha;
